import { Platform, ScrollView } from 'react-native';
import { ScrollView as GestureHandlerScrollView } from 'react-native-gesture-handler';

export const ActionSheetScrollView = Platform.select({
  native: GestureHandlerScrollView as unknown as typeof ScrollView,
  web: ScrollView,
}) as unknown as typeof ScrollView;
